var map = {
	"./banner.jpg": "9b0f",
	"./banner_en.jpg": "4c55",
	"./banner_es.jpg": "9df7",
	"./banner_hk.jpg": "9610",
	"./banner_pt.jpg": "a099",
	"./banner_tr.jpg": "deb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f36";